module.exports = __webpack_public_path__ + "assets/e35deeee72aa6f32087b33d4c30cf17c.mp3";